"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentMetaFormToJSON = exports.AttachmentMetaFormFromJSONTyped = exports.AttachmentMetaFormFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentMetaFormFromJSON(json) {
    return AttachmentMetaFormFromJSONTyped(json, false);
}
exports.AttachmentMetaFormFromJSON = AttachmentMetaFormFromJSON;
function AttachmentMetaFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sealLocation': !runtime_1.exists(json, 'sealLocation') ? undefined : _1.SealLocationEnumFromJSON(json['sealLocation']),
        'signatureLocation': !runtime_1.exists(json, 'signatureLocation') ? undefined : _1.SignatureLocationEnumFromJSON(json['signatureLocation']),
        'fields': (json['fields'].map(_1.AttachmentFieldFromJSON)),
    };
}
exports.AttachmentMetaFormFromJSONTyped = AttachmentMetaFormFromJSONTyped;
function AttachmentMetaFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sealLocation': _1.SealLocationEnumToJSON(value.sealLocation),
        'signatureLocation': _1.SignatureLocationEnumToJSON(value.signatureLocation),
        'fields': (value.fields.map(_1.AttachmentFieldToJSON)),
    };
}
exports.AttachmentMetaFormToJSON = AttachmentMetaFormToJSON;
//# sourceMappingURL=AttachmentMetaForm.js.map